var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.chargeFailed)?_c('call-charge-error'):_vm._e(),_c('call-details'),(_vm.channel)?_c('div',[(_vm.cordova)?_c('div',[_c('call-cordova')],1):_c('div',[_c('call-agora')],1)]):_vm._e(),(!_vm.currentCall.callInProgress)?_c('div',[_c('call-actions')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }